module.exports = __webpack_public_path__ + "static/media/fruit.6be20662.png";